import ClientsList from "./List";
import ClientsEdit from "./Edit";
import React from "react"; // necessary although it doesn't appear to be used; see https://github.com/microsoft/TypeScript/issues/14118
export default [
    { exact: true, path: "/clients", component: ClientsList },
    { path: "/clients/c", component: ClientsEdit },
    { path: "/clients/e/:cid", component: ClientsEdit },
    { exact: true, path: "/clients/v/:cid", component: ClientsEdit, render: props => <ClientsEdit {...props} readOnly={true} /> }
];
